<template>
  <div>
    <div @click="login" class="absolute h-screen w-screen overflow-hidden" style="z-index: 999;"></div>
  <div class="bg-primary relative h-screen w-screen overflow-hidden z-50">
    <video autoplay loop muted playsinline class="absolute w-auto h-auto z-0 papsi-video">
      <source :src="getVideo()" type="video/mp4" />
    </video>

    <div class="absolute z-10 papsi-overlay"></div>

    <div class="flex items-center p-10 z-20 relative w-full">
      <!-- <img class="pt-5 logo" style="width: 26rem;" :src="getImage('logo')" /> -->
      <div class="flex flex-row justify-center align-center items-center" style="gap: 1rem;">
        <img class="logo" style="width: 7rem;" src="https://resource.pafcpic.net/assets/ga/papsi_icon.png" />
         <!-- <img class="logo" style="width: 23rem;" :src="getImage('logo')" /> -->
        <img class="logo border-l-4 border-white pl-5 py-6" style="width: 10rem;" :src="getImage('pia-4')" />
        <p class="text-white font-semibold text-5xl">PAFCPIC Interactive Assistant</p>
      </div>
      <div class="flex flex-col ml-auto text-right justify-end items-end">
        <p class="text-secondary uppercase font-bold text-4xl text-right">PSO - {{ branchName }}</p>
        <DateTimeControl class="text-white text-right" />
      </div>
    </div>

    <div class="tap-to-start-container absolute z-20 mb-16">
      <p class="tap-to-start text-7xl font-bold text-white uppercase">Tap to Start</p>
    </div>
    
  </div>
  </div>
  
</template>


<script>
import DateTimeControl from "@/components/controls/DateTimeControl.vue";
import mixin from "@/mixins/controls.js";

export default {
  mixins: [mixin],
  components: {
    DateTimeControl
  },
  computed: {
    branchName() {
      return this.$store.state.branch.branch_name || '';
    },
  },
  methods: {
    login() {
      this.$router.push({ name: 'choose-lang-page' });
    },
    getVideo(){
      return `${process.env.VUE_APP_MEDIA_URL}/videos/papsi_video.mp4`;
    }
  },
};
</script>

<style scoped>
.papsi-video {
  top: 50%;
  left: 50%;
  min-width: 100%;
  min-height: 100%;
  transform: translate(-50%, -50%);
}

.papsi-overlay {
  top: 0;
  left: 0;
  width: 100%;
  height: 30%;
  background: linear-gradient(to bottom, rgba(0, 94, 0, 0.8), transparent);
}

@keyframes pulse {
    0% {
        transform: scale(1);
    }

    50% {
        transform: scale(1.1);
        /* Shrink */
    }

    100% {
        transform: scale(1);
        /* Back to original size */
    }
}

.tap-to-start-container {
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 20;
}

.tap-to-start {
  animation: pulse 1.5s ease-in-out infinite;
  text-shadow:
    0 0 16px rgba(0, 128, 0, 1),
    0 0 30px rgba(0, 128, 0, 0.8),
    0 0 50px rgba(0, 128, 0, 0.6),
    0 0 70px rgba(0, 128, 0, 0.4),
    0 0 100px rgba(0, 128, 0, 0.2);
}

@media (min-width: 2500px) {
  .tap-to-start {font-size: 6rem !important;}
  .logo {width: 35rem !important;}
}
</style>
